import { useThirdPartyOrganization } from 'bundles/enterprise-admin/ThirdPartyOrganizationProvider';
import { useProductFeatures } from 'bundles/enterprise-admin/features';
import { IdTypes } from 'bundles/product-features';

export const useEnableLearnerGroups = (organizationId?: string): boolean => {
  const thirdPartyOrganization = useThirdPartyOrganization();
  const id = organizationId ?? thirdPartyOrganization?.id ?? '';
  const { features } = useProductFeatures({
    idType: IdTypes.Organization,
    id,
    skip: !id,
  });
  return features.get('enterprise', 'enableLearnerGroups');
};
